import React, {useRef, useState} from "react";
import {NilFunction} from "../../../../shared/types";
import {NavToggleMenuHandle} from "../../NavToggleMenu/props";
import LanguageCurrencyPickerProps from "../../LanguageCurrencyPicker/props";
import {
  LanguageCurrencyFullScreenHandle
} from "../../LanguageCurrencyPicker/components/LanguageCurrencyFullScreen/props";

const useHeaderMenuOverlay = (onClick?: NilFunction) => {
  const navMenuRef = useRef<NavToggleMenuHandle>(null);
  const [focusedSearch, setFocusedSearch] = useState<boolean>(() => false);
  const [menuOpened, setMenuOpened] = useState<boolean>(() => false);

  const handleMenuClick = () => {
    if (focusedSearch) {
      return;
    }
    navMenuRef.current?.openMenu();
    onClick?.();
    setMenuOpened(true);
  }
  const handleFocusChange = (focus: boolean) => {
    if (menuOpened || focus === focusedSearch) {
      return;
    }
    if (focus) {
      navMenuRef.current?.displayOverlay();
      setFocusedSearch(true);
    } else {
      setFocusedSearch(false);
      navMenuRef.current?.hideOverlay();
    }
  }

  const handleOverlayClick = () => {
    if (focusedSearch) {
      setFocusedSearch(false);
      navMenuRef.current?.hideOverlay();
      return;
    }
    if (menuOpened) {
      navMenuRef.current?.closeMenu();
      setMenuOpened(false);
    }
  }
  const onCloseMenu = () => {
    setMenuOpened(false);
  }
  return {navMenuRef, handleMenuClick, focusedSearch, setFocusedSearch, handleFocusChange, handleOverlayClick, onCloseMenu, menuOpened};
}

const useLanguageCurrencyPicker = (languageCurrencyPicker?: LanguageCurrencyPickerProps, onClick?: NilFunction) => {
  const fullScreenRef = useRef<LanguageCurrencyFullScreenHandle>(null);
  const handleFullScreenClick = () => {
    fullScreenRef.current?.openFullScreen();
    onClick?.();
  }

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>, state: {language: string, currency: string}) => {
    e.preventDefault();
    languageCurrencyPicker?.buttonOnClick?.(e, state);
    fullScreenRef.current?.closeFullScreen();
  }

  const toggleProps = {
    handleToggle: handleFullScreenClick,
    flagCountryUrl: languageCurrencyPicker?.flagCountryUrl || '',
    countryName: languageCurrencyPicker?.countryName || '',
    languageName: languageCurrencyPicker?.languageName || '',
    currencyName: languageCurrencyPicker?.currencyName || '',
    hideCurrency: languageCurrencyPicker?.hideCurrency || false,
  }
  return {fullScreenRef, handleButtonClick, handleFullScreenClick, toggleProps};
}

export { useHeaderMenuOverlay, useLanguageCurrencyPicker };
